import React from 'react';
import Chat from 'components/Chat';
import UserRoute from 'components/Routes/UserRoute';

const routes = [
  <UserRoute key="chat" path="/chat"><Chat/></UserRoute>
];

export default routes;
